<template>
  <div id="scroll-board">
    <dv-scroll-board :config="config" />
  </div>
</template>

<script>
export default {
  name: 'ScrollBoard',
  props: {
    list: Array,
    default: () => []
  },
  data () {
    return {
      config: {
        header: ['本班所有学生列表'],
        data: this.list,
        // index: true,
        columnWidth: [300],
        align: ['center'],
        rowNum: 10,
        headerBGC: '#1981f6',
        headerHeight: 45,
        waitTime: 3000,
        oddRowBGC: 'rgba(0, 44, 81, 0.8)',
        evenRowBGC: 'rgba(10, 29, 50, 0.8)'
      }
    }
  },
  created () {
    debugger
    this.qryDetailData()
  },
  watch: {
    list: {
      immediate: true,
      deep: true,
      handler: function (val, old) {
        this.config = {
          header: ['本班所有学生列表'],
          data: this.list,
          // index: true,
          columnWidth: [300],
          align: ['center'],
          rowNum: 10,
          headerBGC: '#1981f6',
          headerHeight: 45,
          waitTime: 3000,
          oddRowBGC: 'rgba(0, 44, 81, 0.8)',
          evenRowBGC: 'rgba(10, 29, 50, 0.8)'
        }
      }
    }

  },
  methods: {
    qryDetailData () {
      this.config = {
        header: ['本班所有学生列表'],
        data: this.list,
        // index: true,
        columnWidth: [300],
        align: ['center'],
        rowNum: 10,
        headerBGC: '#1981f6',
        headerHeight: 45,
        waitTime: 3000,
        oddRowBGC: 'rgba(0, 44, 81, 0.8)',
        evenRowBGC: 'rgba(10, 29, 50, 0.8)'
      }
    }
  }
}
</script>

<style lang="less">
#scroll-board {
  width: 100%;
  box-sizing: border-box;
  margin-left: 0px;
  height: 100%;
  overflow: hidden;
}
.ceil {
    padding: 0 10px;
    font-size: 30px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.header-item {
    padding: 0 10px;
    font-size: 30px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-transition: all 0.3s;
    transition: all 0.3s;
}
</style>
